<div class="flex flex-col specialGap">
    <mat-label
        class="font-medium areaButtonLabel"
        [ngClass]="field.formControl.disabled ? 'disabled' : ''">
        {{ field.props.label }}
        {{ field.props.required ? '*' : '' }}
    </mat-label>
</div>

<div class="w-full flex flex-row">
    <button
        [disabled]="field.formControl.disabled"
        class="flex-1 areaButton bg-white dark:bg-transparent"
        mat-button
        (click)="openSelectionDialog($event)">
        {{ field.formControl.value }}
    </button>
    <button class="my-auto" *ngIf="field.props.clear" mat-icon-button (click)="clear($event)">
        <mat-icon svgIcon="feather:x"></mat-icon>
    </button>
</div>
